

export function sanitizeCode(val) {
    return val.replace(/ /g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^A-z0-9_]/g, '')
        .toLowerCase();
}